// extracted by mini-css-extract-plugin
export default {"cart_counter_block":"style_cart_counter_block__Op6ov","counterBtn":"style_counterBtn__KCE1+"};